import type { CustomField } from '@/common/api/types/customField';

export function isCustomFieldApplicableToItemType(field: CustomField, itemTypeId: number): boolean {
  if (field.itemTypeAssociationMode === 'ALL') return true;
  return field.associatedItemTypeIds?.includes(itemTypeId) ?? false;
}
